module.exports = __webpack_public_path__ + "doc/CPYDS.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/CPYDS.pdf
// module id = x81K
// module chunks = 1